export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7028331f96f8cb8cb6ce40812deaa508472676cf55&name=pushAdClickData!'